import { render, staticRenderFns } from "./NotFoundComponent.vue?vue&type=template&id=ff9a015c&scoped=true&"
import script from "./NotFoundComponent.vue?vue&type=script&lang=ts&"
export * from "./NotFoundComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9a015c",
  null
  
)

export default component.exports